// App.js 应用顶层组件，用于接驳数据层等

import React, { Component } from 'react';
import { configure } from 'mobx';
import { Provider, observer } from 'mobx-react';
import rootStore from '@/stores';
// 应用路由
import Router from './router';

// 开启mobx严格模式
configure({
    enforceActions: 'observed',
});

@observer
class App extends Component {
    render() {
        return (
            <Provider {...rootStore}>
                <Router />
            </Provider>
        );
    }
}

export default App;
